import React, { useEffect, useState } from "react";
import { PUT, POST, DELETE, GET } from "../constant/apiMethods";
import { MdDeleteForever } from "react-icons/md";
import Labels from "../services/apiLabels";
import { ADD_VEHICLE_AUCTION, VEHICLE_LIST } from "../constant";
import { connect } from "react-redux";
import { AiOutlineEdit } from "react-icons/ai";
import { ImHammer2 } from "react-icons/im";
import carimg from "../assets/images.jpg";
import { AiFillCamera } from "react-icons/ai";
import config from "../config";
import { FaEuroSign } from "react-icons/fa";
import { getAuthUserId } from "../services/localStorage";
import { resolveVehicleImageUrl } from "../utils/sanitizeImageUrl";
import { getBuyNowDisplayPrice } from "../utils/listingPrice";
import ConfirmDialog from "./ConfirmDialog";
import {
  authHeaders,
  isFilled,
  isPositiveNumber,
  readApiResponse,
} from "../utils/formValidation";
export const API_ENDPOINT = (label) => {
  return `${config.baseUrl}${label}`;
};
const Table = ({
  myVehiclesList,
  getAllCars,
  setisEdit,
  setSelectedTabIdx,
  addvechielAuction,
  updatevechielAuction,
  getCarWiners,
  user_id,
  updatedVehicle,
  onCreateListing,
}) => {
  const edit = (item) => {
    setisEdit(item);
    setSelectedTabIdx(1);
  };
  const [showModal, setShowModal] = React.useState(false);
  const [deleteTarget, setDeleteTarget] = React.useState(null);
  const [deleting, setDeleting] = React.useState(false);
  const [listingVehicle, setListingVehicle] = React.useState(null);
  const [price, setPrice] = React.useState("");
  const [opening_price, setopening_price] = React.useState("");
  const [cur_price, setcur_price] = React.useState("");
  const [lowest_price, setlowest_price] = React.useState("");
  const [increment_value, setincrement_value] = React.useState("");
  const [start_date, setstart_date] = React.useState("");
  const [end_date, setend_date] = React.useState("");
  const [status, setstatus] = React.useState(false);
  const [buynowStatus, setBuynowStatus] = React.useState(false);
  const [radio, setRadio] = React.useState("auction");
  const [product_id, setproduct_id] = React.useState();
  const [auctionData, setauctionData] = React.useState(null);
  const [buynowData, setBuynowData] = React.useState(null);
  const [startDateSelected, setStartDateSelected] = useState(false);
  const [auctionArray, setAuctionArray] = useState(null)
  const [radioVisible, setRadioVisble] = useState(true)
  const [savingListing, setSavingListing] = useState(false);
  const [listingError, setListingError] = useState("");
  const [touched, setTouched] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  console.log(updatedVehicle)
  const handleStartDateChange = (event) => {
    setStartDateSelected(true);
  };

  console.log("my vehicle list", myVehiclesList)
  const convertTime = (date) => {
    const dateString = date;
    const userOffset = new Date().getTimezoneOffset() * 60 * 1000;
    const localDate = new Date(dateString);
    const utcDate = new Date(localDate.getTime() + userOffset);
    return utcDate;
  };
  const requestDelete = (item) => {
    setDeleteTarget(item);
  };

  const cancelDelete = () => {
    if (deleting) return;
    setDeleteTarget(null);
  };

  const confirmDelete = () => {
    if (!deleteTarget?.id || deleting) return;
    setDeleting(true);
    const payload = {
      label: `${Labels.delvechiel}${deleteTarget.id}/`,
      method: DELETE,
      hideOverlayLoader: true,
    };
    fetchData(payload, () => {
      setDeleting(false);
      setDeleteTarget(null);
    });
  };

  const openListingModal = (item) => {
    setListingVehicle(item);
    const auctions = Array.isArray(item.auction) ? item.auction : [];
    if (auctions.length > 0) {
      setauctionData(auctions[0]);
      setproduct_id(item.id);
      setShowModal(true);
      setRadioVisble(false);
      setRadio("auction");
    } else {
      setauctionData(null);
      setproduct_id(item.id);
      setShowModal(true);
      if (item.buy_now) {
        setRadioVisble(false);
        setRadio("buynow");
      } else {
        setRadioVisble(true);
        setRadio("auction");
      }
    }
    setBuynowData({
      buy_now_price: item.buy_now_price,
      buy_now: item.buy_now,
      id: item.id,
    });
  };

  const closeListingModal = () => {
    setShowModal(false);
    setStartDateSelected(false);
    setopening_price("");
    setcur_price("");
    setlowest_price("");
    setincrement_value("");
    setstart_date("");
    setend_date("");
    setstatus(false);
    setauctionData(null);
    setBuynowData(null);
    setRadio("auction");
    setRadioVisble(true);
    setPrice("");
    setBuynowStatus(false);
    setListingVehicle(null);
    setListingError("");
    setTouched({});
    setSubmitAttempted(false);
  };

  const listingLabel = (item) => {
    if (item?._evaluationOnly) {
      return { text: "Evaluation", tone: "unlisted" };
    }
    const auctions = Array.isArray(item.auction) ? item.auction : [];
    if (auctions.length > 0) return { text: "Auction", tone: "auction" };
    if (item.buy_now) return { text: "Buy now", tone: "buynow" };
    return { text: "Unlisted", tone: "unlisted" };
  };
  function fetchData(payload, onDone) {
    const { label, data, method } = payload;

    fetch(API_ENDPOINT(label), {
      method,
      headers: authHeaders(),
      body: data,
    })
      .then(async (response) => {
        const parsed = await readApiResponse(
          response,
          "Unable to delete vehicle."
        );
        if (parsed.ok) {
          getAllCars();
        }
      })
      .catch(() => {})
      .finally(() => {
        if (typeof onDone === "function") onDone();
      });
  }

  function formatDate(timestamp) {
    const dateObj = new Date(timestamp);

    const year = dateObj.getFullYear();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const hours = ("0" + dateObj.getHours()).slice(-2);
    const minutes = ("0" + dateObj.getMinutes()).slice(-2);

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  useEffect(() => {
    if (!deleteTarget) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") cancelDelete();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [deleteTarget, deleting]);

  console.log(status, "start_date--------------", auctionData);
  useEffect(() => {
    if (auctionData) {
      setopening_price(auctionData.opening_price);
      setcur_price(auctionData.cur_price);
      setlowest_price(auctionData.lowest_price);
      setincrement_value(auctionData.increment_value);
      setstart_date(formatDate(convertTime(auctionData.start_date)));
      setend_date(formatDate(convertTime(auctionData.end_date)));
      setstatus(auctionData.status);
      setStartDateSelected(true);
    } else {
      setopening_price("");
      setcur_price("");
      setlowest_price("");
      setincrement_value("");
      setstart_date("");
      setend_date("");
      setstatus(false);
    }
  }, [auctionData]);
  console.log(buynowData)
  useEffect(() => {
    if (buynowData) {
      console.log("buynow useeffect working",buynowData)
      setPrice(buynowData?.buy_now_price)
      setBuynowStatus(buynowData.buy_now)
    } else {
      setPrice("")
      setBuynowStatus(false)
    }
  }, [buynowData])
  const listingFieldErrors = (() => {
    const errors = {};
    if (radio === "buynow") {
      if (!isPositiveNumber(price)) errors.price = "Enter a price greater than 0";
    } else {
      if (!isPositiveNumber(opening_price)) {
        errors.opening_price = "Enter an opening price greater than 0";
      }
      if (!isPositiveNumber(lowest_price)) {
        errors.lowest_price = "Enter a reserve price greater than 0";
      }
      if (!isPositiveNumber(increment_value)) {
        errors.increment_value = "Enter an increment greater than 0";
      }
      if (!isFilled(start_date)) errors.start_date = "Required";
      if (!isFilled(end_date)) errors.end_date = "Required";
      if (start_date && end_date && end_date <= start_date) {
        errors.end_date = "End date must be after the start date";
      }
    }
    return errors;
  })();
  const isListingValid = Object.keys(listingFieldErrors).length === 0;
  const showListingError = (key) =>
    Boolean((submitAttempted || touched[key]) && listingFieldErrors[key]);
  const markListingTouched = (key) =>
    setTouched((prev) => (prev[key] ? prev : { ...prev, [key]: true }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);
    if (!isListingValid || savingListing) return;

    let label;
    let method;
    let body;
    if (radio === "auction") {
      body = {
        created_by: getAuthUserId(),
        product_id: product_id,
        opening_price: opening_price,
        cur_price: auctionData ? cur_price : opening_price,
        lowest_price: lowest_price,
        increment_value: increment_value,
        start_date: start_date,
        end_date: end_date,
        status: status,
      };
      if (auctionData) {
        label = `${Labels.updatevechielAuction}${auctionData.id}/?type=auction`;
        method = PUT;
      } else {
        label = `${Labels.addvechielAuction}?type=auction`;
        method = POST;
      }
    } else {
      body = {
        buy_now: buynowStatus,
        buy_now_price: price,
      };
      if (buynowData?.id) {
        label = `${Labels.updatevechielAuction}${buynowData.id}/?type=buy_now`;
        method = PUT;
      } else {
        label = `${Labels.addvechielAuction}?type=buy_now`;
        method = POST;
      }
    }

    setSavingListing(true);
    setListingError("");
    try {
      const response = await fetch(API_ENDPOINT(label), {
        method,
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify(body),
      });
      const parsed = await readApiResponse(
        response,
        "Unable to save listing. Please try again."
      );
      if (!parsed.ok) {
        setListingError(parsed.description);
        return;
      }
      getAllCars();
      closeListingModal();
    } catch (err) {
      setListingError("Unable to save listing. Please try again.");
    } finally {
      setSavingListing(false);
    }
  };
  useEffect(()=>{
    if(updatedVehicle){
      getCarWiners(user_id)
    }
  },[updatedVehicle])
  return (
    <div className="flex  flex-col">
      <ConfirmDialog
        open={Boolean(deleteTarget)}
        title="Delete vehicle?"
        message={
          <p>
            You are about to permanently remove{" "}
            <strong>{deleteTarget?.name || "this vehicle"}</strong>
            {deleteTarget?.brand_name
              ? ` (${deleteTarget.brand_name}${
                  deleteTarget.model_name ? ` ${deleteTarget.model_name}` : ""
                })`
              : ""}
            . This cannot be undone.
          </p>
        }
        confirmLabel="Delete"
        confirming={deleting}
        confirmingLabel="Deleting…"
        onCancel={cancelDelete}
        onConfirm={confirmDelete}
      />
      {showModal ? (
        <div
          className="dd-listing"
          role="dialog"
          aria-modal="true"
          aria-labelledby="dd-listing-title"
        >
          <button
            type="button"
            className="dd-listing__backdrop"
            aria-label="Close listing dialog"
            onClick={closeListingModal}
          />
          <form className="dd-listing__panel" onSubmit={handleSubmit} noValidate>
            <header className="dd-listing__head">
              <div>
                <p className="dd-listing__eyebrow">
                  {auctionData || buynowData?.buy_now
                    ? "Update listing"
                    : "Create listing"}
                </p>
                <h3 id="dd-listing-title">
                  {listingVehicle?.name || "List vehicle"}
                </h3>
                {listingVehicle?.brand_name ? (
                  <p className="dd-listing__meta">
                    {[
                      listingVehicle.brand_name,
                      listingVehicle.model_name,
                      listingVehicle.fuel_type,
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                  </p>
                ) : null}
              </div>
              <button
                type="button"
                className="dd-btn dd-btn--ghost"
                onClick={closeListingModal}
              >
                Close
              </button>
            </header>

            <div className="dd-listing__body">
              {radioVisible ? (
                <div className="dd-listing__tabs" role="tablist" aria-label="Listing type">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={radio === "auction"}
                    className={`dd-listing__tab${
                      radio === "auction" ? " is-active" : ""
                    }`}
                    onClick={() => setRadio("auction")}
                  >
                    Auction
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={radio === "buynow"}
                    className={`dd-listing__tab${
                      radio === "buynow" ? " is-active" : ""
                    }`}
                    onClick={() => setRadio("buynow")}
                  >
                    Buy now
                  </button>
                </div>
              ) : (
                <div className="dd-listing__mode">
                  Mode: <strong>{radio === "auction" ? "Auction" : "Buy now"}</strong>
                </div>
              )}

              {radio === "buynow" ? (
                <div className="dd-form-grid">
                  <div
                    className={`dd-field${
                      showListingError("price") ? " is-invalid" : ""
                    }`}
                  >
                    <label htmlFor="dd-buy-price">Price *</label>
                    <input
                      type="number"
                      id="dd-buy-price"
                      name="price"
                      min="0"
                      step="0.01"
                      value={price}
                      placeholder="Enter price"
                      onChange={(e) => {
                        markListingTouched("price");
                        setPrice(e.target.value);
                      }}
                    />
                    {showListingError("price") ? (
                      <p className="dd-password__error">
                        {listingFieldErrors.price}
                      </p>
                    ) : null}
                  </div>
                  <div className="dd-field dd-field--check">
                    <label htmlFor="dd-buy-status">Active status</label>
                    <label className="dd-switch" htmlFor="dd-buy-status">
                      <input
                        type="checkbox"
                        id="dd-buy-status"
                        checked={buynowStatus}
                        onChange={(e) => setBuynowStatus(e.target.checked)}
                      />
                      <span>{buynowStatus ? "Active" : "Inactive"}</span>
                    </label>
                  </div>
                </div>
              ) : null}

              {radio === "auction" ? (
                <div className="dd-form-grid">
                  <div
                    className={`dd-field${
                      showListingError("opening_price") ? " is-invalid" : ""
                    }`}
                  >
                    <label htmlFor="dd-open-price">Opening price *</label>
                    <input
                      disabled={Boolean(auctionData)}
                      type="number"
                      id="dd-open-price"
                      min="0"
                      step="0.01"
                      value={opening_price}
                      placeholder="Opening price"
                      onChange={(e) => {
                        markListingTouched("opening_price");
                        setopening_price(e.target.value);
                      }}
                    />
                    {showListingError("opening_price") ? (
                      <p className="dd-password__error">
                        {listingFieldErrors.opening_price}
                      </p>
                    ) : null}
                  </div>
                  <div className="dd-field">
                    <label htmlFor="dd-cur-price">Current price</label>
                    <input
                      type="number"
                      id="dd-cur-price"
                      disabled
                      value={opening_price}
                      placeholder="Current price"
                    />
                  </div>
                  <div
                    className={`dd-field${
                      showListingError("lowest_price") ? " is-invalid" : ""
                    }`}
                  >
                    <label htmlFor="dd-reserve-price">Reserve price *</label>
                    <input
                      type="number"
                      id="dd-reserve-price"
                      min="0"
                      step="0.01"
                      value={lowest_price}
                      placeholder="Reserve price"
                      onChange={(e) => {
                        markListingTouched("lowest_price");
                        setlowest_price(e.target.value);
                      }}
                    />
                    {showListingError("lowest_price") ? (
                      <p className="dd-password__error">
                        {listingFieldErrors.lowest_price}
                      </p>
                    ) : null}
                  </div>
                  <div
                    className={`dd-field${
                      showListingError("increment_value") ? " is-invalid" : ""
                    }`}
                  >
                    <label htmlFor="dd-increment">Increment *</label>
                    <input
                      type="number"
                      id="dd-increment"
                      min="0"
                      step="0.01"
                      value={increment_value}
                      placeholder="Increment value"
                      onChange={(e) => {
                        markListingTouched("increment_value");
                        setincrement_value(e.target.value);
                      }}
                    />
                    {showListingError("increment_value") ? (
                      <p className="dd-password__error">
                        {listingFieldErrors.increment_value}
                      </p>
                    ) : null}
                  </div>
                  <div
                    className={`dd-field${
                      showListingError("start_date") ? " is-invalid" : ""
                    }`}
                  >
                    <label htmlFor="dd-start-date">Start date *</label>
                    <input
                      type="datetime-local"
                      id="dd-start-date"
                      value={start_date}
                      onChange={(e) => {
                        markListingTouched("start_date");
                        setstart_date(e.target.value);
                        handleStartDateChange();
                      }}
                    />
                    {showListingError("start_date") ? (
                      <p className="dd-password__error">
                        {listingFieldErrors.start_date}
                      </p>
                    ) : null}
                  </div>
                  <div
                    className={`dd-field${
                      showListingError("end_date") ? " is-invalid" : ""
                    }`}
                  >
                    <label htmlFor="dd-end-date">End date *</label>
                    <input
                      type="datetime-local"
                      id="dd-end-date"
                      value={end_date}
                      min={start_date}
                      onChange={(e) => {
                        markListingTouched("end_date");
                        const newEndDate = e.target.value;
                        if (start_date && newEndDate < start_date) {
                          setend_date("");
                          return;
                        }
                        setend_date(newEndDate);
                      }}
                    />
                    {showListingError("end_date") ? (
                      <p className="dd-password__error">
                        {listingFieldErrors.end_date}
                      </p>
                    ) : null}
                  </div>
                  <div className="dd-field dd-field--check">
                    <label htmlFor="dd-auction-status">Active status</label>
                    <label className="dd-switch" htmlFor="dd-auction-status">
                      <input
                        type="checkbox"
                        id="dd-auction-status"
                        checked={status}
                        onChange={(e) => setstatus(e.target.checked)}
                      />
                      <span>{status ? "Active" : "Inactive"}</span>
                    </label>
                  </div>
                </div>
              ) : null}
            </div>

            <footer className="dd-listing__foot">
              {listingError ? (
                <p className="dd-password__error" role="alert">
                  {listingError}
                </p>
              ) : null}
              <button
                type="button"
                className="dd-btn dd-btn--ghost"
                onClick={closeListingModal}
                disabled={savingListing}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="dd-btn dd-btn--primary"
                disabled={!isListingValid || savingListing}
              >
                {savingListing ? "Saving…" : "Save listing"}
              </button>
            </footer>
          </form>
        </div>
      ) : null}
      <div className="dd-table-wrap overflow-x-auto">
        <div className="align-middle inline-block min-w-full">
          <div className="overflow-hidden table-wrapper">
            <table className="dd-table min-w-full table-class divide-y-2 divide-gray-200 ">
              <thead className="active-color text-white">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-2.5 text-left text-base  tracking-wider"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-2.5 text-left text-base  tracking-wider"
                  >
                    Vehicle
                  </th>

                  <th
                    scope="col"
                    className="px-6 py-2.5 text-left text-base  tracking-wider"
                  >
                    Price
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-2.5 text-left text-base  tracking-wider"
                  >
                    Image
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-2.5 text-left text-base  tracking-wider"
                  >
                    Listing
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-2.5 text-left text-base  tracking-wider whitespace-nowrap"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 ">
                {(myVehiclesList || []).map((item) => {
                  const listing = listingLabel(item);
                  return (
                    <tr key={item.id}>
                      <td className="px-6 py-3.5 whitespace-nowrap">
                        {item.name || "-"}
                      </td>
                      <td className="px-6 py-3.5 whitespace-nowrap">
                        {item.brand_name
                          ? `${item.brand_name}${
                              item.model_name ? `-${item.model_name}` : ""
                            }${item.fuel_type ? `-${item.fuel_type}` : ""}${
                              item.year ? `-${item.year}` : ""
                            }`
                          : "-"}
                      </td>
                      <td className="px-6 py-3.5 whitespace-nowrap">
                        <span
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <FaEuroSign size={15} />{" "}
                          {(() => {
                            const displayPrice = getBuyNowDisplayPrice(item);
                            return displayPrice != null && displayPrice !== ""
                              ? Number(displayPrice).toLocaleString()
                              : "-";
                          })()}
                        </span>
                      </td>
                      <td className="px-6 py-3.5 whitespace-nowrap">
                        <img
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                          src={resolveVehicleImageUrl(item, carimg)}
                          alt=""
                        />
                      </td>
                      <td className="px-6 py-3.5 whitespace-nowrap">
                        <span
                          className={`dd-chip dd-chip--${listing.tone}${
                            item.status ? "" : " is-muted"
                          }`}
                        >
                          {listing.text}
                          {!item._evaluationOnly && !item.status ? " · off" : ""}
                        </span>
                      </td>
                      <td className="px-6 py-3.5">
                        <div className="dd-actions" role="group" aria-label="Vehicle actions">
                          {item._evaluationOnly ? (
                            <button
                              type="button"
                              className="dd-action"
                              title="Add listing details to sell this vehicle"
                              aria-label="Add listing details to sell this vehicle"
                              onClick={() =>
                                typeof onCreateListing === "function" &&
                                onCreateListing(item)
                              }
                            >
                              <ImHammer2 size={15} aria-hidden />
                              <span>List for sale</span>
                            </button>
                          ) : (
                            <>
                              <button
                                type="button"
                                className="dd-action"
                                title="Edit vehicle"
                                aria-label="Edit vehicle"
                                onClick={() => edit(item)}
                              >
                                <AiOutlineEdit size={16} aria-hidden />
                                <span>Edit</span>
                              </button>
                              <button
                                type="button"
                                className="dd-action"
                                title="List for auction or buy now"
                                aria-label="List for auction or buy now"
                                onClick={() => openListingModal(item)}
                              >
                                <ImHammer2 size={15} aria-hidden />
                                <span>List</span>
                              </button>
                            </>
                          )}
                          {item.inspect_id ? (
                            <button
                              type="button"
                              className="dd-action"
                              title="Open inspection"
                              aria-label="Open inspection"
                              onClick={() => {
                                window.open(
                                  `/inspection/dealerinspection?id=${encodeURIComponent(
                                    item.inspect_id
                                  )}`,
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              }}
                            >
                              <AiFillCamera size={16} aria-hidden />
                              <span>Inspect</span>
                            </button>
                          ) : null}
                          {!item._evaluationOnly && item.allow_delete ? (
                            <button
                              type="button"
                              className="dd-action dd-action--danger"
                              title="Delete vehicle"
                              aria-label="Delete vehicle"
                              onClick={() => requestDelete(item)}
                            >
                              <MdDeleteForever size={16} aria-hidden />
                              <span>Delete</span>
                            </button>
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user_id: state.auth.id,
  // Do not map myVehiclesList here — parent (tabs2) passes the filtered/paged list.
  updatedVehicle: state?.myVehicles?.updateData,
});

const mapDispatchToProps = (dispatch) => ({
  // get product list
  addvechielAuction: (data, type) =>
    dispatch({
      type: ADD_VEHICLE_AUCTION,
      payload: {
        type: ADD_VEHICLE_AUCTION,
        data,
        label: `${Labels.addvechielAuction}?type=${type}`,
        method: POST,
        hideOverlayLoader: true,
      },
    }),
  updatevechielAuction: (data, id, type) =>
    dispatch({
      type: ADD_VEHICLE_AUCTION,
      payload: {
        type: ADD_VEHICLE_AUCTION,
        data,
        label: `${Labels.updatevechielAuction}${id}/?type=${type}`,
        method: PUT,
        hideOverlayLoader: true,
      },
    }),
    getCarWiners: (id) =>
    dispatch({
      type: VEHICLE_LIST,
      payload: {
        type: VEHICLE_LIST,
        label: `${Labels.vechiellist}${id}/`,
        method: GET,
        hideOverlayLoader: true,
        hideSuccessToaster: true,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);